import React, { useEffect } from 'react'
import cookie from 'js-cookie'
import { addDays, toDate } from 'date-fns'
import pushRoute from '../pushRoute'
import { useIntl } from 'react-intl'
import getRoutes from '@/lib/getRoutes'
import LOCAL_STORAGE from '@/src/localstorage'
import getLocaleFromCtx from '@/lib/getLocaleFormCtx'
import getTokenFromCtx from '@/lib/getTokenFormCtx'

export const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const login = ({
  token,
  keepConnected,
  historyBack,
  customRoute = null,
  customUrl = null,
}) => {
  const date = new Date()
  const timestamp = Math.round(date.getTime() / 1000)
  date.setTime((timestamp + token?.ttl) * 1000)

  const expires = keepConnected
    ? {
        expires: date,
        secure: true,
        path: '/',
        sameSite: 'lax',
      }
    : {}
  cookie.set(LOCAL_STORAGE.name_cookie_token, JSON.stringify(token), expires)
  cookie.set('controlJobTitle', 'true', {
    expires: toDate(addDays(new Date(), 1)),
  })

  const cookieWindowReferer = cookie.get('referer')

  // Gestion du cookie popup
  if (!cookie.get('openPopupBrand')) {
    /* cookie.set('openPopupBrand', 'true', {
      expires: toDate(addDays(new Date(), 15)),
    })*/
  }

  if (historyBack && !!cookieWindowReferer) {
    if (cookieWindowReferer) {
      window.location.replace(cookieWindowReferer)
    } else window.history.go(-1)
  } else if (customUrl) {
    window.location.replace(`${window.location.origin}/${customUrl}`)
  } else if (customRoute) {
    pushRoute(customRoute)
  } else {
    pushRoute(getRoutes({ route: 'Home' }))
  }
}

export const auth = ctx => {
  const locale = getLocaleFromCtx(ctx)
  const token = getTokenFromCtx(ctx)

  //le skeyProduct sert pour l'authentification  des produits en prévisualisation
  const query = ctx.query
  const skeyProduct = query?.skeyProduct

  const byPassPrevisualisation = !!skeyProduct && ctx.pathname.includes('products')

  const apiKey = token?.token
  /*
   * If `ctx.req` is available it means we are on the server.
   * Additionally if there's no token it means the user is not logged in.
   */

  if (ctx.req && !apiKey && !byPassPrevisualisation) {
    ctx.res.setHeader('Set-Cookie', `referer=${ctx.req.url}; Path=/`)
    ctx.res.writeHead(302, { Location: `/${locale}/customer/login?redirect=yes` })
    ctx.res.end()
  }

  // We already checked for server. This should only happen on client.
  if (!apiKey && typeof window !== 'undefined' && !byPassPrevisualisation) {
    pushRoute({ href: '/[locale]/customer/login', as: `/${locale}/customer/login?redirect=yes` })
  }

  return token
}

export const logout = async ({ locale }) => {
  await pushRoute({ href: '/[locale]/customer/login', as: `/${locale}/customer/login` })
  // to support logging out from all windows
  window.localStorage.setItem('logout', String(Date.now()))
  cookie.remove(LOCAL_STORAGE.name_cookie_token)
  cookie.remove('referer')
}

export const withAuthSync = WrappedComponent => {
  const Wrapper = props => {
    const { locale } = useIntl()
    const syncLogout = event => {
      if (event.key === 'logout') {
        pushRoute({
          href: '/[locale]/customer/login?redirect=yes',
          as: `/${locale}/customer/login?redirect=yes`,
        })
      }
    }

    useEffect(() => {
      window.addEventListener('storage', syncLogout)

      return () => {
        window.removeEventListener('storage', syncLogout)
        window.localStorage.removeItem('logout')
      }
    }, [null])

    return <WrappedComponent {...props} />
  }

  Wrapper.getInitialProps = async ctx => {
    const token = auth(ctx)

    const componentProps =
      WrappedComponent.getInitialProps && (await WrappedComponent.getInitialProps(ctx))

    return { ...componentProps, token }
  }

  return Wrapper
}
